@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$checkbox-size: 20px;

[data-fpsm-theme='gazzetta'] {
  .checkbox.shouldHighlightOnChecked.checked {
    background-color: var(--cxy-color-interactive-tertiary);
  }
}

.checkbox {
  border-radius: var(--cxy-border-radius-s);

  &.shouldHighlightOnChecked {
    padding: var(--cxy-spacing-xxsm);

    &.checked {
      background-color: color-mix(in srgb, var(--cxy-color-surface-page), transparent 90%);
    }
  }

  @include cxy.screen-size('desktop') {
    @include cxy.font-size('text-m', var(--cxy-fontWeight-normal));
  }
}

.checkboxBox {
  width: $checkbox-size;
  height: $checkbox-size;
  border: var(--cxy-border-default);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  padding: 0;

  &,
  .indicator {
    display: flex;
    border-radius: 1px;
    color: var(--cxy-color-icon-checkbox);
    > svg {
      color: var(--cxy-color-icon-checkbox);
      fill: var(--cxy-color-icon-checkbox);
    }
  }

  &[data-state='checked'] {
    background-color: var(--cxy-color-brand);
    border-color: var(--cxy-color-brand);

    .indicator,
    .checkIcon {
      visibility: visible;
    }
  }
}

.checkboxGroup {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-xxxsm);
  color: var(--cxy-color-text-default-body);

  legend {
    @include cxy.font-size('text-s');

    padding: var(--cxy-spacing-xxsm);
  }
}
